import { baseApi } from "@/shared/api";
import type { GphContract, GphCompletionAct, CreateCompletionActDto, UpdateCompletionActDto, ProjectOption } from "../types";

export const gphContractApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGphContract: builder.query<GphContract, void>({
      query: () => ({
        url: "/api/hr/self-service/gph-contract/",
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "GphContract" as const, id: "CONTRACT" }],
    }),

    getSelfServiceProjects: builder.query<ProjectOption[], void>({
      query: () => ({
        url: "/api/hr/self-service/projects/",
        method: "GET",
        credentials: "include" as const,
      }),
      transformResponse(response: ProjectOption[] | { results?: ProjectOption[] }) {
        return Array.isArray(response) ? response : (response?.results ?? []);
      },
      providesTags: [{ type: "Projects" as const, id: "SELF_SERVICE" }],
    }),

    createCompletionAct: builder.mutation<GphCompletionAct, CreateCompletionActDto>({
      query: (body) => ({
        url: "/api/hr/self-service/completion-acts/",
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "GphContract" as const, id: "CONTRACT" }],
    }),

    updateCompletionAct: builder.mutation<GphCompletionAct, { id: number; body: UpdateCompletionActDto }>({
      query: ({ id, body }) => ({
        url: `/api/legal/completion-acts/${id}/`,
        method: "PATCH",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [
        { type: "GphContract" as const, id: "CONTRACT" },
        { type: "CompletionActs" as const, id: "LIST" },
      ],
    }),

    deleteCompletionAct: builder.mutation<void, number>({
      query: (id) => ({
        url: `/api/legal/completion-acts/${id}/`,
        method: "DELETE",
        credentials: "include" as const,
      }),
      invalidatesTags: [
        { type: "GphContract" as const, id: "CONTRACT" },
        { type: "CompletionActs" as const, id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetGphContractQuery,
  useGetSelfServiceProjectsQuery,
  useCreateCompletionActMutation,
  useUpdateCompletionActMutation,
  useDeleteCompletionActMutation,
} = gphContractApi;

